import "./header.css";
import logoSSA from "../../imagens/logos/logoSSA.png";
import bandeiraBrasil from "../../imagens/flags/br.png";
import bandeiraEUA from "../../imagens/flags/us.png";

import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";

function Header() {
    const [show, setShow] = useState(false);
    const { t, i18n } = useTranslation();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("lang", lang);
    };

    return (
        <header className="container-fluid p-0 m-0" id="header">
            <nav className="navbar navbar-expand-lg d-flex justify-content-between p-0 ps-1">

                {/* LOGO */}
                <div className="LogoImage">
                    <Link to="/">
                        <img src={logoSSA} alt="Logo SSA" />
                    </Link>
                </div>

                {/* BOTÃO MOBILE */}
                <Button
                    onClick={handleShow}
                    className="navbar-toggler me-4 mt-2 d-lg-none custom-off-canvas-btn"
                >
                    <FontAwesomeIcon icon={faBars} />
                </Button>

                {/* MENU DESKTOP */}
                <div className="collapse navbar-collapse justify-content-end align-items-center">
                    <ul className="nav align-items-center">

                        <li className="nav-item">
                            <Link className="nav-link" to="/">{t("menu.home")}</Link>
                        </li>

                        {/* --- NOVO DROPDOWN EMPRESA (DESKTOP) --- */}
                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link dropdown-toggle"
                                to="#"
                                role="button"
                                data-bs-toggle="dropdown"
                            >
                                {t("menu.company")} {/* Alterar no JSON para "Empresa" */}
                            </Link>
                            <ul className="dropdown-menu">
                                <li>
                                    <Link className="dropdown-item" to="/AboutUs">
                                        {t("menu.about")}
                                    </Link>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <Link className="dropdown-item" to="/Sustainability">
                                        {t("menu.sustainability")} {/* Alterar no JSON */}
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        {/* --------------------------------------- */}

                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link dropdown-toggle"
                                to="#"
                                role="button"
                                data-bs-toggle="dropdown"
                            >
                                {t("menu.capabilities")}
                            </Link>
                            <ul className="dropdown-menu">
                                <li>
                                    <Link className="dropdown-item" to="/Capabilities/Production">
                                        {t("menu.cap_prod")}
                                    </Link>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <Link className="dropdown-item" to="/Capabilities/Engineering">
                                        {t("menu.cap_eng")}
                                    </Link>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <Link className="dropdown-item" to="/Capabilities/ToolingAndManufacturing">
                                        {t("menu.cap_tool")}
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link dropdown-toggle"
                                to="#"
                                role="button"
                                data-bs-toggle="dropdown"
                            >
                                {t("menu.contacts")}
                            </Link>
                            <ul className="dropdown-menu">
                                <li>
                                    <Link className="dropdown-item" to="/ContactUs">
                                        {t("menu.contact_us")}
                                    </Link>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <Link className="dropdown-item" to="/Denuncia">
                                        {t("menu.whistleblower")}
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/Certificates">
                                {t("menu.certificates")}
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/Customers">
                                {t("menu.customers")}
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/News">
                                {t("menu.news")}
                            </Link>
                        </li>
                    </ul>

                    {/* BANDEIRAS DESKTOP */}
                    <Nav className="flag-nav d-none d-lg-flex flex-column align-items-center ps-5 pe-2">
                        <p className="mb-0 fw-bold choose-lang-text">{t("footer.chooseLanguage")}:</p>
                        <div className="d-flex justify-content-center">
                            <Button variant="link" onClick={() => handleLanguageChange("pt")} className="flag-button-header p-1">
                                <Image src={bandeiraBrasil} alt="Português" className="flag-icon-custom" />
                            </Button>
                            <Button variant="link" onClick={() => handleLanguageChange("en")} className="flag-button-header p-1">
                                <Image src={bandeiraEUA} alt="English" className="flag-icon-custom" />
                            </Button>
                        </div>
                    </Nav>

                </div>

                {/* OFFCANVAS MOBILE — ESPELHO DO DESKTOP */}
                <Offcanvas className="" show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title className="title">Menu</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="p-0">
                        <ul className="nav flex-column offcanvas-nav p-0">

                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleClose}>
                                    {t("menu.home")}
                                </Link>
                            </li>

                            {/* --- NOVO DROPDOWN EMPRESA (MOBILE) --- */}
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    {t("menu.company")}
                                </Link>
                                <ul className="dropdown-menu position-static">
                                    <li>
                                        <Link className="dropdown-item" to="/AboutUs" onClick={handleClose}>
                                            {t("menu.about")}
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <Link className="dropdown-item" to="/Sustainability" onClick={handleClose}>
                                            {t("menu.sustainability")}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            {/* -------------------------------------- */}

                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    {t("menu.capabilities")}
                                </Link>
                                <ul className="dropdown-menu position-static">
                                    <li>
                                        <Link className="dropdown-item" to="/Capabilities/Production" onClick={handleClose}>
                                            {t("menu.cap_prod")}
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <Link className="dropdown-item" to="/Capabilities/Engineering" onClick={handleClose}>
                                            {t("menu.cap_eng")}
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <Link className="dropdown-item" to="/Capabilities/ToolingAndManufacturing" onClick={handleClose}>
                                            {t("menu.cap_tool")}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    {t("menu.contacts")}
                                </Link>
                                <ul className="dropdown-menu position-static">
                                    <li>
                                        <Link className="dropdown-item" to="/ContactUs" onClick={handleClose}>
                                            {t("menu.contact_us")}
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <Link className="dropdown-item" to="/Denuncia" onClick={handleClose}>
                                            {t("menu.whistleblower")}
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/Certificates" onClick={handleClose}>
                                    {t("menu.certificates")}
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/Customers" onClick={handleClose}>
                                    {t("menu.customers")}
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/News" onClick={handleClose}>
                                    {t("menu.news")}
                                </Link>
                            </li>
                        </ul>

                        {/* BANDEIRAS MOBILE */}
                        <div className="d-flex justify-content-center align-items-center gap-3 py-4">
                            <p className="mb-0 fw-bold">{t("footer.chooseLanguage")}:</p>
                            <Button variant="link" onClick={() => handleLanguageChange("pt")} className="flag-button p-0">
                                <Image src={bandeiraBrasil} alt="Português" className="flag-icon-custom" />
                            </Button>
                            <Button variant="link" onClick={() => handleLanguageChange("en")} className="flag-button p-0">
                                <Image src={bandeiraEUA} alt="English" className="flag-icon-custom" />
                            </Button>
                        </div>


                    </Offcanvas.Body>
                </Offcanvas>

            </nav>
        </header>
    );
}

export default Header;